<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <vuexy-logo />
        </b-link>

        <!-- form -->
        <validation-observer ref="loginValidation" v-if="step == 0">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- email -->
            <b-form-group label-for="username" :label="$i18n.messages.email">
              <validation-provider
                #default="{ errors }"
                :name="$i18n.messages.email"
                rules="required|email"
              >
                <b-form-input
                  id="username"
                  v-model="username"
                  name="login-username"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$i18n.messages.email"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group label-for="password" :label="$i18n.messages.password">
              <validation-provider
                #default="{ errors }"
                :name="$i18n.messages.password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    :placeholder="$i18n.messages.password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <p class="forgot-password text-right mt-2 mb-4">
              <!--  <router-link to="/forgot-password"
                >¿Olvidó su contraseña?</router-link
              > -->
              <b-button
                variant="link"
                style="border-style: none;"
                @click="step = 1"
              >
                {{ $i18n.messages.forgotpassword }}
              </b-button>
            </p>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              @click="validationForm"
            >
              {{ $i18n.messages.login }}
            </b-button>
          </b-form>
        </validation-observer>

        <!-- form -->
        <validation-observer ref="forgotValidation" v-if="step == 1">
          <b-button
            size="sm"
            variant="secondary"
            class="my-2 btn-action "
            style="border-style: none; margin-bottom:0 !important; margin-top:0 !important"
            @click="step = 0"
          >
            <feather-icon icon="ArrowLeftIcon" size="25" />
          </b-button>
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- email -->
            <!--   <b-form-group label-for="username" :label="$i18n.messages.usuario">
              <validation-provider
                #default="{ errors }"
                :name="$i18n.messages.usuario"
                rules="required"
              >
                <b-form-input
                  id="username"
                  v-model="username"
                  name="login-username"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$i18n.messages.usuario"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group> -->

            <!-- email -->
            <b-form-group label-for="email" :label="$i18n.messages.email">
              <validation-provider
                #default="{ errors }"
                :name="$i18n.messages.email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$i18n.messages.email"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              style="margin-top:30px;"
              block
              @click="validationFormForgot"
            >
              {{ $i18n.messages.sendEmail }}
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Login v1 -->
    </div>
    <modal-disclaimer></modal-disclaimer>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BCard,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BCardTitle,
  BForm,
  BButton,
} from "bootstrap-vue";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ModalDisclaimer from "@/views/ModalDisclaimer.vue";

export default {
  components: {
    BCard,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardTitle,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    ModalDisclaimer,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      username: "",
      email: "",
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      // validation rulesimport store from '@/store/index'
      required,
      step: 0,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  created() {
    localStorage.removeItem("user");
    localStorage.removeItem("cart");
    localStorage.removeItem("currentCustomer");
  },
  methods: {
    ...mapActions({
      login: "auth/login",
      forgot: "auth/forgot",
    }),
    ...mapMutations({
      setShowModalDisclaimer: "auth/setShowModalDisclaimer",
      setLoading: "app/setLoading",
    }),
    async openModalLogin() {
      this.setLoading(true);
      await this.setShowModalDisclaimer(true);
      this.setLoading(false);
    },
    validationForm() {
      var setShowModalDisclaimer = this.setShowModalDisclaimer;
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          const { username, password } = this;

          if (username && password) {
            this.login({
              username,
              password,
              setShowModalDisclaimer,
              toast: this.$toast,
            });
          }
        }
      });
    },
    validationFormForgot() {
      var setShowModalDisclaimer = this.setShowModalDisclaimer;
      console.log("AAAA");
      this.$refs.forgotValidation.validate().then((success) => {
        if (success) {
          console.log("SUCCES");
          const { email } = this;

          if (email) {
            this.forgot({
              email,
              setShowModalDisclaimer,
              toast: this.$toast,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
